import React, { useEffect, useState } from 'react'
import { LeshenPhoneCTA, useMapi } from '@leshen/gatsby-theme-leshen'

const DynamicPhoneCTA = () => {
  const { rotatedNumber, requestId } = useMapi()
  const [isCaliforniaStatePage, setIsCaliforniaStatePage] = useState(false)
  const [isCaliforniaCityPage, setIsCaliforniaCityPage] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname
      setIsCaliforniaStatePage(
        path.includes('/availability/ca') && !path.includes('/availability/ca/')
      )
      setIsCaliforniaCityPage(
        path.includes('/availability/ca/') && path !== '/availability/ca'
      )
    }
  }, [])

  return isCaliforniaStatePage ? (
    <LeshenPhoneCTA
      color="primary"
      requestId={requestId}
      staticPhoneNumber="855-662-4703"
      cobra="Hide CTA"
      cobraCartUrl={`https://www.dish.com/clearlink/packages/?tfn=855-662-4703&alt_rep_id=DA87178&site_location=${requestId}`}
    >
      Call
    </LeshenPhoneCTA>
  ) : isCaliforniaCityPage ? (
    <LeshenPhoneCTA
      color="primary"
      requestId={requestId}
      staticPhoneNumber="855-662-4704"
      cobra="Hide CTA"
      cobraCartUrl={`https://www.dish.com/clearlink/packages/?tfn=855-662-4704&alt_rep_id=DA87178&site_location=${requestId}`}
    >
      Call
    </LeshenPhoneCTA>
  ) : (
    <LeshenPhoneCTA
      color="primary"
      requestId={requestId}
      cobra="Hide CTA"
      cobraCartUrl={`https://www.dish.com/clearlink/packages/?tfn=${rotatedNumber}&alt_rep_id=DA87178&site_location=${requestId}`}
    >
      Call
    </LeshenPhoneCTA>
  )
}

export default DynamicPhoneCTA
